import { IContent } from "@kunduz/data-access-cms-api";
import { UserReviewCta } from "@kunduz/ui-components";
import { trackEventNext } from "@kunduz/utility-analytics";
import React, { ReactElement } from "react";

export const UserReviewCtaWithContext = (props: Props): ReactElement => {
  const handleClick = () => {
    trackEventNext({
      event: "User Review Banner Clicked",
    });
  };

  return (
    <UserReviewCta
      title={props.data.title}
      theme={props.data.color as any}
      reviewUrl={props.data.review_url}
      reviewUrlTarget={props.data.review_url_target}
      rating={props.data.rating}
      ratingText={props.data.rating_text}
      reviewText={props.data.review}
      onClick={handleClick}
    />
  );
};

interface Props {
  data: IContent.UserReviewCtaComponentData;
}
